const colorOptions = [
  'orange',
  'lightpink',
  'aliceblue',
  'red',
  'green',
  'blue',
  'grey',
  'pink',
  'indigo',
];

export { colorOptions };
